import React from "react";
import ReactDOM from "react-dom";
import { init } from "@rematch/core";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { ThemeProvider } from "@material-ui/styles";
import { StylesProvider } from "@material-ui/core/styles";
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./views/App";
import i18n from "./i18n";
import * as serviceWorker from "./serviceWorker";
import "./assets/style/index.scss";
import models from "./state";
import theme from "./theme";
import { CookiesProvider } from "react-cookie";
import { AutoRegistration } from "./containers/AutoRegistration";
// import LocalServiceWorkerRegister from './sw-register';

const store = init({
  models,
});

toast.configure();
export const { dispatch } = store;

ReactDOM.render(
  <StylesProvider>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <CookiesProvider>
            {window.location.pathname === "/autoRegistration" || window.location.pathname === "/spa/autoRegistration" ? (
              <AutoRegistration />
            ) : (
              <App />
            )}
            <ToastContainer autoClose={8000} limit={2} />
          </CookiesProvider>
        </I18nextProvider>
      </Provider>
    </ThemeProvider>
  </StylesProvider>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
// LocalServiceWorkerRegister();
